<!--
  Forbrukerrådet - Kommunetesten
  @link https://gitlab01.copyleft.no/FBR/kommunetesten-new
  @author Anders Evenrud <anders.evenrud@copyleft.no>
-->

<template>
  <div class="circles">
    <ul>
      <li v-for="(row, index) in items" :key="index">
        <div class="circles__outer">
          <div class="circles__label">{{ row.label }}</div>

          <div class="circles__container">
            <div class="circles__pie">
              <div class="circles__pie__graph">
                <svg viewBox="0 0 36 36" class="circle">
                  <path class="circle__bg"
                    d="M18 2.0845
                    a 15.9155 15.9155 0 0 1 0 31.831
                    a 15.9155 15.9155 0 0 1 0 -31.831" />

                  <path class="circle__fg"
                    :stroke-dasharray="stroke(index)"
                    d="M18 2.0845
                    a 15.9155 15.9155 0 0 1 0 31.831
                    a 15.9155 15.9155 0 0 1 0 -31.831" />
                </svg>
              </div>
              <div class="circles__pie__score">{{ decimalLabel(row.score) }}</div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
@import "../assets/variables";

.circles {
  line-height: normal;

  ul {
    margin: 0;
    padding: 0;
    list-style-type: none;
    display: flex;

    li {
      margin: 0;
      padding: 0;
      display: flex;
      flex: 1 1 33.333%;
      flex-direction: column;
      text-align: center;
      overflow: hidden;

      &:nth-child(1) {
        align-items: flex-start;

        & > div { /* outer */
          max-width: 200px;
        }
      }

      &:nth-child(2) {
        align-items: center;
      }

      &:nth-child(3) {
        align-items: flex-end;
      }
    }
  }

  &__outer {
    max-width: 160px;
    width: 100%;
    height: 100%;
  }

  &__container {
    max-width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  &__label {
    position: relative;
    z-index: 20;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: normal;
  }

  &__pie {
    position: relative;
    z-index: 10;
    padding: 1em;

    /*&__graph {
    }*/

    &__score {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 170%;
    }
  }
}

.circle {
  width: 100%;

  &__bg {
    fill: none;
    stroke: $circles-background;
    stroke-width: $circles-stroke;
  }

  &__fg {
    stroke: $circles-foreground;
    fill: none;
    stroke-width: $circles-stroke;
    animation: circle-progress 0.5s ease-out forwards;
  }
}

@keyframes circle-progress {
  0% {
    stroke-dasharray: 0 100;
  }
}

@media (max-width: 400px) {
  .circles__pie__score {
    font-size: 140%;
  }
}
</style>

<script>
export default {
  props: {
    items: Array
  },

  methods: {
    stroke (index) {
      return `${this.items[index].score}, 100`
    }
  }
}
</script>
